import 'babel-polyfill';
import 'url-search-params-polyfill';
import Vue from 'vue';
import VueLocalStorage from 'vue-localstorage';
import Helper from './src/core/Helper';
import Reporter from './src/core/Reporter';
import EventHandler from './src/core/EventHandler';
import ViewPort from './src/core/ViewPort';

window._ = require('lodash');

window.queryString = require('query-string');

window.$ = window.jQuery = require('jquery');

window.Cookies = require('js-cookie');

require('foundation-sites');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error(
        'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.Vue = Vue;

window.Vue.use(VueLocalStorage);

window.Helper = Helper;

window.Reporter = new Reporter;

window.EventHandler = new EventHandler;

window.ViewPort = new ViewPort;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
